"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.consolidateErrors = void 0;
const MAX_ROWS_PER_GROUP = 10;
const MAX_GROUPS = 10;
// Consolidate given error objects into structured errors
// This function groups errors by a key, and then formats the error messages
// for each group. It returns the top 10 groups with the highest occurrences.
// Each group is represented as a structured error.
const consolidateErrors = (errors, groupBy, mapRow, formatMessage) => {
    const groupedErrors = new Map(); // key -> errors
    errors.forEach((error) => {
        const key = groupBy(error);
        if (!groupedErrors.has(key)) {
            groupedErrors.set(key, []);
        }
        groupedErrors.get(key)?.push(error);
    });
    // Create an array with group keys and their counts
    const errorsWithCount = Array.from(groupedErrors.entries()).map(([key, groupErrors]) => ({
        key,
        groupErrors,
        count: groupErrors.length,
    }));
    // Take the top MAX_GROUPS groups with the highest occurrences
    const topErrors = errorsWithCount
        .sort((a, b) => b.count - a.count)
        .slice(0, MAX_GROUPS);
    // Consolidate into structured errors
    const structuredTransformErrors = topErrors.map(({ key, groupErrors }) => {
        const rows = groupErrors.map(mapRow);
        // Keep 10 rows and omit the rest
        const omittedRows = Math.max(rows.length - MAX_ROWS_PER_GROUP, 0);
        rows.splice(MAX_ROWS_PER_GROUP);
        const externalMessage = formatMessage(key);
        return {
            type: 'structuredError',
            message: externalMessage,
            structuredError: {
                externalMessage,
                tableData: { rows, omittedRows },
            },
        };
    });
    // if we omitted any groups, add a message to indicate that
    const groupsOmitted = Math.max(errorsWithCount.length - MAX_GROUPS, 0);
    if (groupsOmitted) {
        const message = `Other [${groupsOmitted}] group of errors were omitted`;
        structuredTransformErrors.push({
            type: 'structuredError',
            message,
            structuredError: {
                externalMessage: message,
            },
        });
    }
    return structuredTransformErrors;
};
exports.consolidateErrors = consolidateErrors;
//# sourceMappingURL=consolidateErrors.js.map